// src/components/PrivateRoute.jsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAppContext } from "../context/AppContext";

const PrivateRoute = () => {
  const { state } = useAppContext();
  const isLoggedIn = !!state.user; // derive from context
  const location = useLocation();

  if (!isLoggedIn) {
    // Store the route user tried to access
    localStorage.setItem("redirectTo", location.pathname);
    return <Navigate to="/login" replace />;
  }

  return <Outlet />; // Render nested routes
};

export default PrivateRoute;
